import screen from './Edit';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/CategoryModels/Edit/index.js